import React from "react";
import { useNavigate, Link } from "react-router-dom";
import SEOHead from "../components/SEOHead";
import { getAuth } from "firebase/auth";

function CoverLetterGuide() {
  const navigate = useNavigate();
  const auth = getAuth();

  const handleStart = () => {
    if (auth.currentUser) {
      navigate("/");
    } else {
      navigate("/get-started");
    }
  };

  return (
    <div style={{ padding: "40px", maxWidth: "900px", margin: "0 auto" }}>

      <SEOHead
        title="How to Write a Cover Letter (2026 Guide)"
        description="Learn how to write a professional cover letter that gets noticed. Step-by-step guide, examples, and tips to land interviews faster."
        canonical="https://employpilot.com/cover-letter-guide"
      />

      <h1>How to Write a Cover Letter That Gets You Hired</h1>

      <p style={{ fontSize: "18px", color: "#555" }}>
        A strong cover letter can be the difference between getting ignored and getting interviewed.
        Here’s how to write one that stands out.
      </p>

      <button onClick={handleStart} style={btnPrimary}>
        Start Building Your Resume
      </button>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>What Is a Cover Letter?</h2>

      <p>
        A cover letter is a short introduction that explains why you’re the right
        candidate for a job — beyond what’s listed on your resume.
      </p>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>Cover Letter Structure</h2>

      <ol>
        <li><strong>Opening:</strong> Introduce yourself and the role</li>
        <li><strong>Body:</strong> Highlight your skills and experience</li>
        <li><strong>Closing:</strong> Show enthusiasm and ask for next steps</li>
      </ol>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>Example Cover Letter</h2>

      <div style={{ background: "#f9f9f9", padding: "20px", borderRadius: "8px" }}>
        <p>Dear Hiring Manager,</p>

        <p>
          I am excited to apply for the position at your company. My skills in communication,
          teamwork, and problem-solving make me a strong candidate.
        </p>

        <p>
          I am eager to contribute and grow within your organization. Thank you for your time and consideration.
        </p>

        <p>Sincerely,<br />Your Name</p>
      </div>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>Tips for a Strong Cover Letter</h2>

      <ul>
        <li>✔ Keep it short (under 1 page)</li>
        <li>✔ Customize it for each job</li>
        <li>✔ Avoid repeating your resume</li>
        <li>✔ Show personality and confidence</li>
      </ul>

      {/* INTERNAL LINKS */}
      <p style={{ marginTop: "20px" }}>
        Need a resume first?{" "}
        <Link to="/ai-resume-builder">
          Use our AI Resume Builder
        </Link>
      </p>

      <p>
        No experience?{" "}
        <Link to="/resume-no-experience">
          Learn how to write a resume with no experience
        </Link>
      </p>

      {/* CTA */}
      <div style={{ marginTop: "50px", textAlign: "center" }}>
        <h2>Start Your Job Application Today</h2>

        <button onClick={handleStart} style={btnSuccess}>
          Get Started Free
        </button>
      </div>

      {/* FAQ */}
      <h2 style={{ marginTop: "60px" }}>FAQs</h2>

      <h3>Do I need a cover letter?</h3>
      <p>Yes — many employers still expect one.</p>

      <h3>How long should it be?</h3>
      <p>Keep it under one page.</p>

      <h3>Should I use the same cover letter for every job?</h3>
      <p>No — always tailor it.</p>
<div
    style={{
      marginTop: "80px",
      textAlign: "center",
      fontSize: "14px",
      color: "#777",
      borderTop: "1px solid #eee",
      paddingTop: "30px"
    }}
  >
    © 2026 EmployPilot. All Rights Reserved.

    <div style={{ marginTop: "10px" }}>
      <a href="/terms" style={{ margin: "0 10px" }}>
        Terms of Use
      </a>

      <a href="/privacy" style={{ margin: "0 10px" }}>
        Privacy Policy
      </a>

      <a href="/contact" style={{ margin: "0 10px" }}>
        Contact
      </a>
    </div>
  </div>
</div>
  );
}

const btnPrimary = {
  backgroundColor: "#007bff",
  color: "#fff",
  padding: "12px 20px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer",
  marginTop: "20px"
};

const btnSuccess = {
  backgroundColor: "#28a745",
  color: "#fff",
  padding: "14px 24px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer"
};

export default CoverLetterGuide;